import { useLayoutEffect, useRef, useState } from 'react';

export const useContainerScale = (baseWidth = 1130) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);

  useLayoutEffect(() => {
    const measure = () => {
      const container = containerRef.current;
      if (!container) return;
      setScale(container.offsetWidth / baseWidth);
    };

    measure();
    window.addEventListener('resize', measure);

    return () => {
      window.removeEventListener('resize', measure);
    };
  }, [baseWidth]);

  return { containerRef, scale };
};
